import Hero from "../../components/web/section/Hero";
import Layout from "../../components/web/Layout";
import Heading from "../../components/ui/heading/Heading";
import Container from "../../components/ui/container/Container";
import Gallery from "../../components/web/section/Gallery";
import { MdShoppingCart } from "react-icons/md";
import { FaCheckCircle, FaHeart } from "react-icons/fa";
import { useSelector } from "react-redux";
import { getFileUrl, strToSlug } from "../../utils/helper";
import { Link } from "react-router-dom";
import { PRODUCT_ROUTE } from "../../routes/web/rootRoutes";
import placeHolderImage from "../../assets/images/placeholder/product.jpg";
import { useDispatch } from "react-redux";
import { addToCart, addToWishlist, getHomeData } from "../../store/slice/userActions";
import toast from "react-hot-toast";
import { Helmet } from "react-helmet";
import ProductCard from "../../components/web/product/ProductCard";
import InfiniteScroll from "react-infinite-scroll-component";
import { useEffect, useState } from "react";
import { getProductsApi } from "../../utils/guest/api";
import UserAuth from "../../middleware/UserAuth";
import VendorCard from "../../components/web/vendor/VendorCard";
import HeroSection from "../../components/web/ui/HeroSection";

const Home = () => {
  const siteSetting = useSelector((state) => state.globalState.siteSetting);
  const isLoading = useSelector((state) => state.user.loading);
  const products = useSelector((state) => state.user.products);
  const dispatch = useDispatch();


  const siteName = useSelector(
    (state) => state?.globalState?.siteSetting?.site_settings?.site_name
  );

  const homeData = useSelector((state) => state?.user?.homeData);


  useEffect(() => {
    if (homeData.length === 0) {
      dispatch(getHomeData());
    }
  }, [dispatch, homeData]);

  return (
    <>
      <Layout>
        <Helmet>
          <title>{siteName}</title>
        </Helmet>
        <Hero
          imageList={siteSetting?.homepage_settings?.homepage_banners ?? []}
        />
        {
          homeData?.vendors && homeData?.vendors?.length > 0 && (
            <Container className="mt-6">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-5 p-3">
              {homeData?.vendors?.map(vendor => (
                <VendorCard key={vendor?._id} vendor={vendor} />
              ))}
              </div>
            </Container>)
        }
        {/* <HeroSection/> */}

      </Layout>
    </>

  );
};

export default Home;
